// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import drawcss from './assets/css/drawer.css'
import iziModel from './assets/css/iziModal.css'
import VModal from 'vue-js-modal'
// Amplify
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import awsconfig from './aws-exports'
// Mixin(Util)
import mixin from './mixins/Util.js'
import wordUtil from './mixins/WordUtil.js'
import imageUtil from './mixins/ImageUtil.js'
import linkUtil from './mixins/LinkUtil.js'
import resultUtil from './mixins/ResultUtil.js'
// Indicator
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
// Cookie
import VueCookie from 'vue-cookies';
Vue.use(VueCookie);

Vue.use(VModal)
Amplify.configure(awsconfig)
Vue.use(AmplifyPlugin, AmplifyModules)
Vue.mixin(mixin)
Vue.use(Loading)
Vue.mixin(wordUtil)
Vue.mixin(imageUtil)
Vue.mixin(linkUtil)
Vue.mixin(resultUtil)

Vue.config.productionTip = false

// JMEC
import('../static/css/layout_1.css')
// C-edge
// import('../static/css/layout_2.css')
// Contact YM
// import('../static/css/layout_3.css')

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  drawcss,
  iziModel,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js